import React from 'react';
import { ElementSelector } from '@bingads-webui-campaign-react/element-selector';
import {
  withSiteMap,
  processorSet,
} from '@bingads-webui-campaign-react/with-site-map';

import { DefaultSubTabLoader } from './default-sub-tab-loader';

const CampaignSubTabLoader = withSiteMap(DefaultSubTabLoader, processorSet.all);

export const SubTabContainer = React.memo(props => (
  <ElementSelector fallback={(null)}>
    <CampaignSubTabLoader {...props} />
  </ElementSelector>
));
